import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Menu, Button, Carousel, Icon, Modal, Empty, Typography } from 'antd'
import { ComponentExt } from 'util/reactExt'
import solidImg from 'assets/lecturerLevelup/soild.png'
import { chunk } from 'lodash'
import * as styles from './index.scss'

const { Paragraph } = Typography

interface IProps extends RouteComponentProps<any> {}
interface IState {
  informStatus: boolean
  informData: string[]
  selectedKeys: string[]
  tabList: any
  tabListActive: {
    id: number
    name: string
  }
  carouselData: {
    count: number
    pages: number
    carouselList: any
  }
  slickActive: number
}

class Glory extends ComponentExt<IProps, IState> {
  slider: any = undefined // 解决slider报错

  state = {
    informStatus: false,
    informData: [],
    selectedKeys: ['1'],
    tabList: [],
    tabListActive: {
      id: 1,
      name: '',
    },
    carouselData: {
      count: 0,
      pages: 0,
      carouselList: [],
    },
    slickActive: 0,
  }

  componentDidMount() {
    const time: any = new URLSearchParams(this.props.location.search).get(
      'time',
    )
    const currentTime = Date.now()
    let id = 1
    if (time && currentTime - time < 5000) {
      this.setState({
        selectedKeys: ['5'],
        tabListActive: {
          id: 5,
          name: '投资顾问',
        },
      })
      id = 5
    }
    this.handleGloryTabDetails(id)
    this.handleGloryTabList()
  }

  // 获取左侧按钮
  async handleGloryTabList() {
    try {
      const tabList = await this.api.lecturer.getLecturerGloryTabList({})
      const itme = tabList[0] || {}
      this.setState({
        tabList,
        tabListActive: {
          id: itme.id,
          name: itme.name,
        },
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  // 获取列表
  async handleGloryTabDetails(id: number) {
    const contentType = {
      1: 1,
      2: 1,
      3: 1,
      4: 2,
      5: 3,
    }
    const contentPages = {
      4: 3,
      5: 10,
    }
    const pages = contentType[id]
    const checkNum = contentPages[id]
    try {
      const res = await this.api.lecturer.getLecturerGloryTabDetails({
        id,
      })
      let carouselList = res.data

      if (checkNum) {
        carouselList = chunk(res.data, checkNum)
      }

      this.setState({
        carouselData: {
          count: res.count,
          pages,
          carouselList,
        },
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  // menus切换
  toggleMenus = tab => {
    const { key, item } = tab
    this.setState({
      selectedKeys: [key],
      tabListActive: {
        id: Number(key),
        name: item.props.children,
      },
    })
    this.handleGloryTabDetails(Number(key))
  }

  slickGoTo = idx => {
    this.setState(
      {
        slickActive: idx,
      },
      () => {
        this.slider.slick.slickGoTo(idx)
      },
    )
  }

  carouselChange = index => {
    this.setState({ slickActive: index })
  }

  // 获取晋升列表
  async handleGloryPromoteMsg() {
    try {
      const data = await this.api.lecturer.getLecturerStudyPromoteMsg({})
      this.setState({ informData: data })
    } catch (err) {
      console.error(err.message)
    }
  }

  // 显示晋升消息
  showModal = () => {
    this.handleGloryPromoteMsg()
    this.setState({
      informStatus: true,
    })
  }

  // 关闭晋升消息
  handleCancel = () => {
    this.setState({
      informStatus: false,
    })
  }

  render() {
    const {
      informStatus,
      informData,
      selectedKeys,
      tabList,
      tabListActive,
      slickActive,
      carouselData: { pages, carouselList, count },
    } = this.state

    return (
      <div className={`${styles.wrapper} gloryWrap`}>
        <div className={styles.menus}>
          <Menu
            mode="inline"
            theme="light"
            selectedKeys={selectedKeys}
            onSelect={this.toggleMenus}
            style={{ height: '100%', backgroundColor: '#222221' }}
          >
            {tabList.map(item => (
              <Menu.Item key={item.id}>{item.name}</Menu.Item>
            ))}
          </Menu>
        </div>

        <div className={styles.content}>
          <div className={styles.counselorCommon}>
            <Carousel
              autoplay={false}
              dots={pages === 1 ? false : true}
              ref={el => (this.slider = el)}
              afterChange={this.carouselChange}
            >
              {pages === 1 &&
                carouselList.map(item => (
                  <div key={item.staff_id} className={styles.highCounselor}>
                    <div className={styles.title}>
                      <div className={styles.text}>
                        <p>{item.year}</p>
                        <p>经传</p>
                        <h3>{tabListActive.name}</h3>
                      </div>
                      <img src={item.head_img || item.bust_img} />
                    </div>
                    <div className={styles.describeWrap}>
                      <div className={styles.name}>
                        <h2>{item.name}</h2>
                        <p>{item.motto}</p>
                        <Button
                          type="primary"
                          href={`/#/searchresult?q=${item.name}`}
                          style={{
                            width: 106,
                            height: 40,
                            display: 'block',
                            lineHeight: '40px',
                            backgroundColor: '#222221',
                            color: '#cca86d',
                            borderColor: '#222221',
                          }}
                        >
                          讲师观点
                          <Icon
                            type="caret-right"
                            style={{ verticalAlign: 0, marginLeft: 0 }}
                          />
                        </Button>
                      </div>
                      <div className={styles.describe}>
                        <p className={styles.title}>个人简介</p>
                        <div>
                          <p>
                            "{item.name}，执业编号：{item.employee_number}
                          </p>
                          <p>{item.introduction}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              {(pages === 2 || pages === 3) &&
                carouselList.map((item, index) => (
                  <div key={index} className={styles.counselor}>
                    <h2 className={styles.title}>
                      <img src={solidImg} alt="左" />
                      <span>{tabListActive.name}</span>
                      <img src={solidImg} alt="右" />
                    </h2>
                    <div className={styles.carousel}>
                      <ul className={pages === 2 ? styles.listA : styles.listB}>
                        {item.map(item => (
                          <li key={item.staff_id}>
                            <img src={item.head_img} alt={item.name} />
                            <p>{item.name}</p>
                            <p>座右铭：{item.motto}</p>
                            <Paragraph
                              ellipsis={{ rows: 3, expandable: true }}
                              style={{
                                fontSize: '16px',
                                color: '#a3a3a3',
                                textAlign: 'justify',
                                paddingLeft: '16px',
                                paddingRight: '16px',
                                overflow: 'auto',
                                maxHeight: '148px',
                              }}
                            >
                              简介：{item.introduction}
                            </Paragraph>

                            {/* <p><Paragraph ellipsis={{ rows: 3, expandable: true }}>简介：{item.introduction}</Paragraph></p> */}
                            {/* <p>简介：{item.introduction}</p> */}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <Button
                      href={`/#/glory/gather?id=${tabListActive.id}`}
                      style={{
                        display: pages === 3 ? 'block' : 'none',
                        maxWidth: 120,
                        margin: '0 auto',
                        color: '#ccad86',
                        borderColor: '#ccad86',
                        backgroundColor: '#323232',
                      }}
                    >
                      查看全部({count})
                    </Button>
                  </div>
                ))}
            </Carousel>

            <Icon
              type="left"
              className={`${styles.iconLeft} ${styles.iconCommon}`}
              style={{ display: pages === 1 ? 'none' : 'block' }}
              onClick={() => {
                this.slider.slick.slickNext()
              }}
            />

            <Icon
              type="right"
              className={`${styles.iconRight} ${styles.iconCommon}`}
              style={{ display: pages === 1 ? 'none' : 'block' }}
              onClick={() => {
                this.slider.slick.slickPrev()
              }}
            />
          </div>

          {pages === 1 && (
            <ul className={styles.highCounselorDots}>
              {carouselList.map((item, idx) => (
                <li
                  className={slickActive === idx ? styles.slickActive : ''}
                  key={item.name}
                  onClick={() => {
                    this.slickGoTo(idx)
                  }}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className={styles.inform}>
          <div onClick={this.showModal}>
            <Icon type="sound" />
            <span>晋升消息</span>
          </div>
          <Modal
            title="晋升消息"
            visible={informStatus}
            footer={null}
            onCancel={this.handleCancel}
          >
            {informData.length > 0 ? (
              informData.map(item => {
                return <p className="modalText">{item}</p>
              })
            ) : (
              <Empty description="暂无晋升消息！" />
            )}
          </Modal>
        </div>
      </div>
    )
  }
}

export default Glory
